let consultationModalLoader: Promise<Window["LeadholdConsultationModal"]> | null = null;

function loadConsultationModal() {
  if (window.LeadholdConsultationModal) {
    return Promise.resolve(window.LeadholdConsultationModal);
  }
  if (consultationModalLoader) return consultationModalLoader;
  consultationModalLoader = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "/landing-assets/consultation-modal.js?v=20260907-1";
    script.addEventListener("load", () => resolve(window.LeadholdConsultationModal), {once: true});
    script.addEventListener("error", reject, {once: true});
    document.head.appendChild(script);
  });
  return consultationModalLoader;
}

export async function openConsultationModal(trigger: HTMLElement | null = null) {
  try {
    if (window.LeadholdOpenConsultationModal) {
      await window.LeadholdOpenConsultationModal(trigger);
      return;
    }
    const controller = await loadConsultationModal();
    await controller?.open({trigger});
  } catch (error) {
    console.error("Не удалось открыть форму консультации.", error);
  }
}
